import type { ReactNode } from 'react';
import type { QuantAnalysisAPIContextValue } from '../../contexts/QuantAnalysisAPIContext';
import { QuantAnalysisAPIContext } from '../../contexts/QuantAnalysisAPIContext';

type Props = {
  children: ReactNode;
  value: QuantAnalysisAPIContextValue;
};

export const QuantAnalysisAPIProvider = ({ children, value }: Props) => {
  return (
    <QuantAnalysisAPIContext.Provider value={value}>
      {children}
    </QuantAnalysisAPIContext.Provider>
  );
};

QuantAnalysisAPIProvider.displayName = 'QuantAnalysisAPIProvider';
